import React from 'react';

import Container from '../container';
import NoticeBanner from '../notice_banner';
import { NoticeProps } from '../../types';

import styles from './style.module.scss';

interface Props extends NoticeProps {
  role: 'sale';
}

const StandaloneNoticeBanner: React.FC<Props> = (props) => {
  return (
    <Container>
      <div className={styles.standaloneNoticeBannerContainer}>
        <NoticeBanner {...props} />
      </div>
    </Container>
  );
};

export default StandaloneNoticeBanner;
